import { put, call, take, fork } from 'redux-saga/effects'
import { AICreatorGenerateOutlineService } from '../../api/ai-creator'
import {
  aICreatorGenerateOutlineSuccess,
  aICreatorGenerateOutlineError,
} from '../../reducers/ai-creator/action'
import { GENERATE_OUTLINE } from '../../reducers/ai-creator/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* generateOutlineFlow(payload) {
  try {
    const { req, callback } = payload

    const response = yield call(AICreatorGenerateOutlineService, req)

    yield put(aICreatorGenerateOutlineSuccess(response == '' ? req : response))
    yield put(operationSuccess())
    callback(response)
  } catch (error) {
    console.error('Outline generation error:', error)
    yield put(
      aICreatorGenerateOutlineError(
        error.message || 'Failed to generate outline',
      ),
    )
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* aICreatorGenerateOutlineWatcher() {
  while (true) {
    const action = yield take(GENERATE_OUTLINE)
    const { payload } = action

    yield fork(generalSaga, generateOutlineFlow, payload, false)
  }
}
